export default __webpack_public_path__ + "static/media/plane5.df084e93.jpg";